function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckmark = function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.6 2.3c.5.4.5 1 .1 1.4l-9.9 10c0 .2-.3.3-.6.3-.2 0-.5-.1-.7-.4l-4.2-5c-.4-.4-.3-1 0-1.4.5-.4 1.1-.3 1.4.1l3.5 4.2 9-9.2c.5-.4 1.1-.4 1.4 0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgIconCheckmark;